import './animation/scroll-out';
import './animation/countup';
import './animation/lazy';

import './core/bullet-list';
import './core/contact-form';
import './core/external-links';
import './core/faq';
import './core/lang-select';
import './core/login';
import './core/navigation';
import './core/sticky-header.js';
import './core/register';
import './core/tabs';

import './components/accordion';
import './tracking/promotion';
import './tracking/sign-up';
import {callUsButton}  from './components/call-us.js';
import {initUITracking} from './tracking/ui-tracking.js';
import {initTeamDirectors} from './components/team-directors.js';

import ConsentPlugin from './package/src/plugins/consent/Consent.vue';
import initSwipers from './core/swiper';
import {createApp}  from 'vue';
import { i18nForCookieConsent } from './i18n.js';
import {initializeMobileFormExpander} from './components/mobile-form-expander';

document.body.classList.remove('preload');
document.documentElement.classList.add('js');

function initializeTracking() {
  const getCookie = (cname) => {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  // FACEBOOK CLICK ID
  const fbClickCookie = getCookie('_fbc');
  if (fbClickCookie) {
    const fbClickId = fbClickCookie.split('.').slice(-1)[0];
    const fbClickInputs = document.documentElement.querySelectorAll('input[name="fb_click_id"]');
    for (var i = 0; i < fbClickInputs.length; i++) {
      fbClickInputs[i].value = fbClickId;
    }
  }


  // MICROSOFT CLICK ID
  const msClickId = new URLSearchParams(window.location.search).get('msclkid') || getCookie('_uetmsclkid');
  if (msClickId) {
    const msClickInputs = document.documentElement.querySelectorAll('input[name="ms_click_id"]');
    for (var i = 0; i < msClickInputs.length; i++) {
      msClickInputs[i].value = msClickId;
    }
  }

  // GOOGLE CLICK ID
  const googleClickCookie = getCookie('_gcl_aw');
  if (googleClickCookie) {
    const googleClickId = googleClickCookie.split('.').slice(-1)[0];
    const googleClickInputs = document.documentElement.querySelectorAll('input[name="google_click_id"]');
    for (var i = 0; i < googleClickInputs.length; i++) {
      googleClickInputs[i].value = googleClickId;
    }
  }

  const getGaUserId = () => {
    /*
      Handling der Google Ad Tracker und Rückgabe eines Komma-separierten Strings
      aller ermittelten IDs

      By WebCC
    */

    const gaCookie = getCookie('_ga');
    return gaCookie ? gaCookie.split('.').slice(-2).join('.') : null;
  }


  const gaId = getGaUserId();
  if (gaId) {
    const gaInputs = document.documentElement.querySelectorAll('input[name="google_id"]');
    for (let i = 0; i < gaInputs.length; i++) {
      gaInputs[i].value = gaId;
    }
  }

}

const stepperElement = document.body.querySelector('.stepper-form');
if (stepperElement)  {
  import('./components/registration-form-stepper.js').then(({registrationFormStepper}) => {
    registrationFormStepper(stepperElement);
  });
}


console.log('app.js loaded');

window.onload = function () {
  const app = createApp(ConsentPlugin);
  app.use(i18nForCookieConsent());
  app.mount(document.getElementById('consent-message'));

  initializeTracking();
  initializeMobileFormExpander();
  initSwipers();
  initUITracking();
  initTeamDirectors();
  callUsButton();

  // Initialize frontend editing for content editors
  if (document.querySelector('[data-section-id]')) {
    import('./frontend-editing.js');

  }
}
